import React from 'react'
import style from "../../Assets/css/style.css";

function SubscriptionAfterLogin() {
  return (
    <div>SubscriptionAfterLogin</div>
  )
}

export default SubscriptionAfterLogin